export const OrderModel = {
    cart: {
        total: 0,
        subtotal: 0,
        total_products: 0,
        products: []
    },
    details: {
        customer_data: {
            name: "",
            surname: "",
            address: "",
            city: "",
            postcode: "",
            phone: "",
            email: "",
            notes: "",
        },
        payment_method: "cash",
        order_type: "tkw",
        tip: 0,
        shipping_fee: 0,
        table: null,
        created_by: "pos",
        created_at: "",
        store: {
            name: "string",
            value: ""
        }
    },
    status: "process"
}